module.exports = __webpack_public_path__ + "static/ygn-7284002fcb63ebf461e3b011887d9a18.jpg";